module.exports = __webpack_public_path__ + "static/media/about-1.8baecb21.jpg";